import { render } from "./history-grid-results.vue?vue&type=template&id=5e1792b0&scoped=true"
import script from "./history-grid-results.vue?vue&type=script&setup=true&lang=js"
export * from "./history-grid-results.vue?vue&type=script&setup=true&lang=js"

import "./history-grid-results.vue?vue&type=style&index=0&id=5e1792b0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1792b0"],['__file',"src/views/history/history-card/components/history-grid-results.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e1792b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e1792b0', __exports__)) {
    api.reload('5e1792b0', __exports__)
  }
  
  module.hot.accept("./history-grid-results.vue?vue&type=template&id=5e1792b0&scoped=true", () => {
    api.rerender('5e1792b0', render)
  })

}


export default __exports__